export default __webpack_public_path__ + "static/media/alley_head.cde2c900.png";